import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import LandingPage from "./pages/LandingPage";
import TourViewer from "./pages/TourViewer";
import AgenciesToscana from "./pages/AgenciesToscana";
import EmailTemplate from "./pages/EmailTemplate";
import StrategiaEnti from "./pages/StrategiaEnti";
import Roadmap from "./pages/Roadmap";
import AdminPanel from "./pages/AdminPanel";
import BrandBook from "./pages/BrandBook";
import LandingHotel from "./pages/LandingHotel";
import LandingCantine from "./pages/LandingCantine";
import LandingWedding from "./pages/LandingWedding";
import LandingDentisti from "./pages/LandingDentisti";
import Academy from "./pages/Academy";
import SeoPlan from "./pages/SeoPlan";
import ChatEmbed from "./pages/ChatEmbed";
import BriefAds from "./pages/BriefAds";
import SocialPlan from "./pages/SocialPlan";
import { VoiceNoteRecorder } from "./components/VoiceNoteRecorder";
import { ChatBot } from "./components/ChatBot";
import { CookieConsent } from "./components/CookieConsent";
import "@/App.css";

function App() {
  useEffect(() => {
    const hideBadge = () => {
      const badge = document.getElementById("emergent-badge");
      if (badge) {
        badge.style.cssText = "display:none!important;visibility:hidden!important;opacity:0!important;width:0!important;height:0!important;overflow:hidden!important;position:fixed!important;pointer-events:none!important;";
        return true;
      }
      return false;
    };
    hideBadge();
    if (!hideBadge()) {
      const iv = setInterval(() => {
        if (hideBadge()) clearInterval(iv);
      }, 500);
      setTimeout(() => clearInterval(iv), 5000);
    }
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/tour/:tourId" element={<TourViewer />} />
          <Route path="/agenzie" element={<AgenciesToscana />} />
          <Route path="/email" element={<EmailTemplate />} />
          <Route path="/enti" element={<StrategiaEnti />} />
          <Route path="/roadmap" element={<Roadmap />} />
          <Route path="/admin" element={<AdminPanel />} />
          <Route path="/brand-book" element={<BrandBook />} />
          <Route path="/hotel" element={<LandingHotel />} />
          <Route path="/cantine" element={<LandingCantine />} />
          <Route path="/wedding" element={<LandingWedding />} />
          <Route path="/dentisti" element={<LandingDentisti />} />
          <Route path="/academy" element={<Academy />} />
          <Route path="/seo-plan" element={<SeoPlan />} />
          <Route path="/chat-embed" element={<ChatEmbed />} />
          <Route path="/brief-ads" element={<BriefAds />} />
          <Route path="/social" element={<SocialPlan />} />
        </Routes>
        <FloatingWidgets />
        <CookieConsent />
      </BrowserRouter>
    </div>
  );
}

function FloatingWidgets() {
  const { pathname } = useLocation();
  if (pathname === "/chat-embed") return null;
  return (
    <>
      <VoiceNoteRecorder />
      <ChatBot />
    </>
  );
}

export default App;
